import {ReactNode} from "react";
import {
  ArrowUturnLeftIcon,
  ChatBubbleLeftIcon,
  CheckIcon,
  EllipsisHorizontalIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/20/solid";
import {ChatBubbleBottomCenterIcon, CheckCircleIcon, ClockIcon} from "@heroicons/react/24/outline";
import T from "platformed-components/i18n/T";

type ReviewStatusInfo = {
  text: ReactNode;
  color?: string;
  icon?: ReactNode;
  actionText?: ReactNode;
  actionedText?: ReactNode;
  overviewIcon?: ReactNode;
};

export const REVIEW_STATUS_MAP: {[status: string]: ReviewStatusInfo} = {
  ["Pending"]: {
    text: <T keyName="c.Awaiting_review" />,
    color: "gray",
    icon: <EllipsisHorizontalIcon />,
    actionText: <T keyName="c.Request_review_from" />,
    actionedText: <T keyName="c.requested_review_from" />,
    overviewIcon: <ClockIcon strokeWidth={2} />,
  },
  ["RequestedChanges"]: {
    text: <T keyName="c.Changes_requested" />,
    color: "red",
    icon: <ExclamationTriangleIcon />,
    actionText: <T keyName="c.Request_changes" />,
    actionedText: <T keyName="c.requested_changes" />,
    overviewIcon: <ArrowUturnLeftIcon strokeWidth={2} />,
  },
  ["Approved"]: {
    text: <T keyName="c.Approved" />,
    color: "green",
    icon: <CheckIcon />,
    actionText: <T keyName="c.Approve" />,
    actionedText: <T keyName="c.approved" />,
    overviewIcon: <CheckCircleIcon strokeWidth={2} />,
  },
  ["Commented"]: {
    text: <T keyName="c.Commented" />,
    color: "blue",
    icon: <ChatBubbleLeftIcon />,
    actionText: <T keyName="c.Comment" />,
    actionedText: <T keyName="c.commented" />,
    overviewIcon: <ChatBubbleBottomCenterIcon strokeWidth={2} />,
  },
  ["Unrequested"]: {text: <T keyName="c.None" />},
};
